import 'whatwg-fetch';
import { apiRoot } from './constants/config';

const makeAbsoluteUrl = (resourcePath) => {
  return `${apiRoot}/${resourcePath}`;
};

const postActivity = (section) => {
  console.log('post activity', section);
  return fetch(
    makeAbsoluteUrl('activity'),
    {
      method: 'POST',
      body: JSON.stringify({
        section
      })
    }
  );
};

export default {
  postActivity,
};
